import { fetchWithAuth } from '../utils/api';
import {
  getCampaignsEndpoints,
  getMarketersEndpoints,
  getPagesEndpoints,
} from './api';

export const loadCampaignsList = async () => {
  try {
    const campaignsEndpoint = getCampaignsEndpoints().LIST;
    const response = await fetchWithAuth(`${campaignsEndpoint}?all=true`);
    if (response.success && response.data) {
      return response.data || [];
    }
  } catch (err) {
    console.error('Load campaigns error:', err);
    return [];
  }
};

export const loadMarketersList = async () => {
  try {
    const marketersEndpoint = getMarketersEndpoints().LIST;
    const response = await fetchWithAuth(`${marketersEndpoint}?all=true`);
    if (response.success && response.data) {
      return response.data || [];
    }
  } catch (err) {
    console.error('Load marketers error:', err);
    return [];
  }
};

export const loadPagesList = async () => {
  try {
    const pagesEndpoint = getPagesEndpoints().LIST;
    const response = await fetchWithAuth(`${pagesEndpoint}?all=true`);
    if (response.success && response.data) {
      return response.data || [];
    }
  } catch (err) {
    console.error('Load pages error:', err);
    return [];
  }
};
